import { AppThunk } from 'store';
import { batch } from 'react-redux';
import { cardsAPI } from 'entities/cards';
import{ StatusLoading } from 'common/constants';
import { getResponseError } from 'common/utils/index';
import { OrderFirstStepOptions } from 'entities/cards';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';

const { setIsLoadingFirstStep, setFirstStep } = slice.actions;
const { setErrorNotice, setSuccessNotice } = applicationActions;

type TOperation = (data: OrderFirstStepOptions) => AppThunk;

const operation: TOperation = (data) => async (dispatch: any) => {
  try {
    dispatch(setIsLoadingFirstStep(StatusLoading.Load));

    const { data: result } = await cardsAPI.orderFirstStep(data);

    batch(() => {
      if (data.nip) dispatch(setSuccessNotice({ translateId: 'orderCardsModal.formSentSuccess' }));
      dispatch(setFirstStep(result));
      dispatch(setIsLoadingFirstStep(StatusLoading.Done));
    });
  } catch (e) {
    const error = await getResponseError(e);
    batch(() => {
      dispatch(setErrorNotice(error));
      dispatch(setIsLoadingFirstStep(StatusLoading.Error));
    });
  }
};

export default operation;
